export const bearingAccuracyMeters = 35;
export const defaultZoom = 18;